var Logger = function () {

    function _log(name) {
        return function () {
            if (!DEBUG || !window.console) return;
            console[name].apply(console, arguments);
        }
    }

    return {
        log: _log('log'),
        warn: _log('warn'),
        error: _log('error')
    };

}();

